import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, CollectionReference } from '@angular/fire/firestore';
import { AuthService } from 'app/core/auth.service';
import { ResponseServiceAction } from 'app/interfaces/response-service.interface';

export enum DirectionEnum {
    Forward = 'Forward',
    Backward = 'Backward',
}

@Injectable({
    providedIn: 'root'
})
export class ResponseServiceActionsHistoryService {
    private readonly collectionName: string = 'responseServiceActionsHistory3';
    private readonly batchLimit: number = 250;

    constructor(private authService: AuthService, private firestore: AngularFirestore) { 
        console.debug('ResponseServiceActionsHistoryService: instantiated');
    }

    async getAllResponseServiceActionsHistoryObjects(clientKey?: string): Promise<ResponseServiceAction[]> {
        let collection: AngularFirestoreCollection<ResponseServiceAction>;

        const chosenClientKey = clientKey || this.authService.appUser.userDetail.clientKey;

        collection = this.firestore.collection<ResponseServiceAction>(this.collectionName, ref => ref.where('clientKey', '==', chosenClientKey).orderBy('dateInitiated', 'desc'));

        try {
            const responseServiceActions: ResponseServiceAction[] = [];

            const snapshot = await collection.get().toPromise();

            snapshot.forEach(doc => {
                responseServiceActions.push(doc.data() as ResponseServiceAction);
            });

            return responseServiceActions;
        }
        catch (error) {
            console.error('Error fetching all response service actions from history:', error);
            throw error;
        }
    }

    async getAllResponseServiceActionsHistoryObjectsBetween(clientKey?: string, startDate?: Date, endDate?: Date): Promise<ResponseServiceAction[]> {
        let collection: AngularFirestoreCollection<ResponseServiceAction>;
        let collection2: AngularFirestoreCollection<ResponseServiceAction>;
        let collection3: AngularFirestoreCollection<ResponseServiceAction>;
    
        const chosenClientKey = clientKey || this.authService.appUser.userDetail.clientKey;

        //Check All Actions where delegateOversightClientKey is also set.
    
        collection = this.firestore.collection<ResponseServiceAction>(this.collectionName, ref => {
            let query = ref.where('clientKey', '==', chosenClientKey).orderBy('dateInitiated', 'desc');
    
            if (startDate) {
                query = query.where('dateInitiated', '>=', startDate);
            }
    
            if (endDate) {
                query = query.where('dateInitiated', '<=', endDate);
            }

            query = query.limit(10000);
    
            return query;
        });

        collection2 = this.firestore.collection<ResponseServiceAction>(this.collectionName, ref => {
            let query = ref.where('responseServiceClientKey', '==', chosenClientKey).orderBy('dateInitiated', 'desc');
    
            if (startDate) {
                query = query.where('dateInitiated', '>=', startDate);
            }
    
            if (endDate) {
                query = query.where('dateInitiated', '<=', endDate);
            }

            query = query.limit(10000);
    
            return query;
        });

        collection3 = this.firestore.collection<ResponseServiceAction>(this.collectionName, ref => {
            let query = ref.where('delegateOversightClientKey', '==', chosenClientKey).orderBy('dateInitiated', 'desc');
    
            if (startDate) {
                query = query.where('dateInitiated', '>=', startDate);
            }
    
            if (endDate) {
                query = query.where('dateInitiated', '<=', endDate);
            }

            query = query.limit(10000);
    
            return query;
        });
    
        try {
            const responseServiceActions: ResponseServiceAction[] = [];
            const snapshot = await collection.get().toPromise();
            const snapshot2 = await collection2.get().toPromise();
            const snapshot3 = await collection3.get().toPromise();
    
            snapshot.forEach(doc => {
                responseServiceActions.push(doc.data() as ResponseServiceAction);
            });

            snapshot2.forEach(doc => {
                if (responseServiceActions.findIndex((action) => action.key == (doc.data() as ResponseServiceAction).key) == -1){
                    responseServiceActions.push(doc.data() as ResponseServiceAction);
                }
            });

            snapshot3.forEach(doc => {
                if (responseServiceActions.findIndex((action) => action.key == (doc.data() as ResponseServiceAction).key) == -1){
                    responseServiceActions.push(doc.data() as ResponseServiceAction);
                }
            });
            
            return responseServiceActions;
        }
        catch (error) {
            console.error('Error fetching all response service actions from history:', error);
            throw error;
        }
    }


    async getResponseServiceActionsHistoryObject(key: string): Promise<ResponseServiceAction> {
        try {
            const snapshot = await this.firestore.doc<ResponseServiceAction>(`${this.collectionName}/${key}`).get().toPromise();

            const responseServiceAction = snapshot.data() as ResponseServiceAction;

            return responseServiceAction;
        }
        catch (error) {
            console.error(`Error fetching response service actions from history with key ${key}:`, error);
            throw error;
        }
    }
}
